 /* global FileReader:true */
 /* global FormData:true */
 /* global window:true */

import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import ReactGA from 'react-ga';
import _ from 'underscore';

import FileInputGroup from '../elements/FileInputGroup';

const TITLE = 'Give parents access to the enterprise portal';

class AddUsersPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            file: null
        };
    }

    componentDidMount() {
        const { actions } = this.props;

        // set breadcrumb
        actions.setBreadcrumb([{ title: TITLE }]);

        // log analytics
        ReactGA.pageview(window.location.pathname);
    }

    handleImageChange = (e) => {
        e.preventDefault();

        const file = e.target.files[0];

        this.setState({ file });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const { actions } = this.props;
        const { file } = this.state;

        const body = new FormData();
        body.append('file', file);

        actions.addUsersCsvRequest(body);
    };

    render() {
        const { profile } = this.props;

        const schoolCode = !_.isNull(profile.school) ? profile.school.school_code : '';
        const schoolTitle = !_.isNull(profile.school) ? profile.school.title : '';

        return (
            <div className="register-wrapper index-1">
                <Helmet title={TITLE} />
                <div className="section-name index-1 container">
                    <div className="col-md-12 resources-title">
                        <h1>{TITLE}</h1>
                        <div className="sep" />
                    </div>
                </div>

                <div className="portfolio-main container" style={{ marginTop: '50px' }}>
                    <div className="row">
                        <div className="col-md-5">
                            <p>We believe that enterprise learning doesn’t have to end in the classroom. We are giving parents the opportunity to access our enterprise portal, provided they have been invited by their child’s primary school.</p><br />
                            <p>To send portal access to parents of your pupils, you can let them know your unique school access code: <span style={{ fontWeight: 'bold', color: '#ff6e32' }}>{schoolCode}</span> and direct them to register a parent account at <a href="https://portal.clevertykes.com/login">portal.clevertykes.com/login</a>.</p><br />
                            <p>Alternatively, if you have permission to do so, you can upload a CSV file of email addresses here. Every email address you add will be automatically sent the portal link on your behalf, along with a unique username and password, so they are able to access the portal.</p><br />
                            <p>Parents will also be notified that they were invited by {schoolTitle}.</p><br />
                            <p>In line with our privacy policy, we never share email addresses with any third party.</p>
                        </div>
                        <div className="col-md-1 col-sm-hidden" />
                        <div className="col-md-6">
                            <form className="ui large form" onSubmit={this.handleSubmit}>
                                <FileInputGroup
                                    name="csv"
                                    label="Upload CSV or excel file" onChange={this.handleImageChange}
                                    toolTip="This file should have the parent email addresses you wish to add in one column, with one email address per line." />
                                <button
                                    className="ui large primary button"
                                    style={{ backgroundColor: '#ff6e32' }}
                                    disabled={profile.isFetching}>
                                    Submit
                                </button>
                                <br />
                                <p>
                                    Once clicking submit, it may take a few moments to complete your request.<br />
                                    Please do not leave or refresh this page until you have received confirmation that your upload was successful.
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

AddUsersPage.propTypes = {
    actions: PropTypes.object,
    profile: PropTypes.object
};

export default AddUsersPage;



/** WEBPACK FOOTER **
 ** ./src/pages/AddUsersPage.js
 **/